import { render } from "./Archive-page.vue?vue&type=template&id=0f23b7b4&scoped=true"
import script from "./Archive-page.vue?vue&type=script&lang=js"
export * from "./Archive-page.vue?vue&type=script&lang=js"

import "./Archive-page.vue?vue&type=style&index=0&id=0f23b7b4&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f23b7b4"]])

export default __exports__